import { useState } from 'react'
import { useRedefinirSenha } from '../../../api/queries/usuarios'
import { Botao } from '../../../components/Botao'
import { Dialogo } from '../../../components/Dialogo'
import { AvisoDeErro } from '../../../components/Estados'
import { CampoDeTexto } from '../../../components/campos'
import { TEXTOS } from '../../../lib/glossario'
import type { UsuarioAdministrado } from '../../../types/usuario'

/**
 * Redefinição de senha por administrador.
 *
 * A senha aparece em texto claro no campo, de propósito: quem administra precisa lê-la para
 * transmiti-la, e um campo mascarado só produziria erro de digitação numa senha que a pessoa nem
 * vai usar duas vezes. Ela é provisória e morre no primeiro acesso.
 *
 * @param props a conta e o que fazer ao fechar
 * @returns o diálogo
 */
export function DialogoDeSenha({ conta, aoFechar }: { conta: UsuarioAdministrado; aoFechar: () => void }) {
  const redefinir = useRedefinirSenha(conta.id)
  const [senha, setSenha] = useState('')

  async function salvar() {
    try {
      await redefinir.mutateAsync(senha)
      aoFechar()
    } catch {
      // O AvisoDeErro mostra o motivo.
    }
  }

  return (
    <Dialogo titulo={`Redefinir a senha de ${conta.nome}`} aoFechar={aoFechar}>
      <div className="space-y-4">
        <p className="max-w-prose text-sm text-slate-600">
          A pessoa entrará com esta senha e será obrigada a trocá-la no mesmo acesso.
        </p>
        <CampoDeTexto
          rotulo="Nova senha provisória"
          ajuda={TEXTOS.usuarios.senhaProvisoria}
          type="text"
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
        />
        {redefinir.isError && <AvisoDeErro erro={redefinir.error} titulo={TEXTOS.usuarios.naoSalvou} />}
        <div className="flex flex-wrap gap-2">
          <Botao aparencia="primario" onClick={salvar} disabled={redefinir.isPending}>
            {redefinir.isPending ? 'Salvando…' : 'Redefinir'}
          </Botao>
          <Botao onClick={aoFechar} disabled={redefinir.isPending}>
            Cancelar
          </Botao>
        </div>
      </div>
    </Dialogo>
  )
}
